// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"202":"main-layout","561":"homeview"}[chunkId] || chunkId) + "." + {"202":"71538f11","318":"e78282b7","561":"9570f834","604":"2bb354b0"}[chunkId] + ".js";
};